export default __webpack_public_path__ + "static/media/grafema_gim-tonico_08.7517ec21.mp4";